export default function useVacancySalary() {
  function vacancySalaryFrom(vacancy) {
    if (vacancy.salary.currency === 'RUB') {
      return `${vacancy.salary?.from} ${vacancy.salary.currencySymbol} `;
    }
    return `${vacancy.salary.currencySymbol} ${vacancy.salary?.from} `;
  }

  function vacancySalaryTo(vacancy) {
    if (vacancy.salary.currency === 'RUB') {
      return `${vacancy.salary?.to} ${vacancy.salary.currencySymbol} `;
    }
    return `${vacancy.salary.currencySymbol} ${vacancy.salary?.to}`;
  }

  return {
    vacancySalaryFrom,
    vacancySalaryTo
  };
}
